angular
	.module 'App.Repository'

.factory 'UnitRepository', ['BaseRepository', (BaseRepository) ->
	class UnitRepository extends BaseRepository
		@resource = '/units'
		@isRestricted = true

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if not do query.isSorted
				query.sortBy 'default', 'DESC'

			super query

	return new UnitRepository
]
